import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'pointer'
  },

  title: {
    height: 'unset',
    padding: '0px 0px 4px 8px'
  }
}))

export default useStyles
